import styled from "styled-components";
import Breakpoints from "../../config/Breakpoints";

const SectionTitle = styled.h2`
    font-size: var(--font-size-2xl);
    font-weight: var(--font-weight-bold);
    text-align: center;
    margin: 0;

    @media ${Breakpoints.max.xs} {
        font-size: var(--font-size-xl);
        text-align: left;
    }
`;

export default SectionTitle;